// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"73fb0490","949":"ea4fb60d"}[chunkId] + ".chunk.js";
};